export default function appConfig(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_APP_CONFIG':
      return { ...state, ...action.payload }
    default:
      return state
  }
}
